import { clusterSpiderEntriesByEqualCoordinate } from './clusterSpiderEntriesByEqualCoordinate';
import { computeSpiderFanOffsetsMeters } from './computeSpiderFanOffsetsMeters';
import { SPIDER_DEFAULT_RADIUS_METERS } from './markerSpider.constants';
import type { SpiderEntry, SpiderPlacement } from './markerSpider.types';
import { offsetLatLngByMetersNorthEast } from './offsetLatLngByMetersNorthEast';

export function computeSpiderPlacements(
  entries: ReadonlyArray<SpiderEntry>,
  radiusMeters: number = SPIDER_DEFAULT_RADIUS_METERS
): Map<number, SpiderPlacement> {
  const result = new Map<number, SpiderPlacement>();
  if (entries.length === 0) {
    return result;
  }

  const groups = clusterSpiderEntriesByEqualCoordinate(entries);

  for (let g = 0; g < groups.length; g += 1) {
    const group = groups[g];
    if (!group || group.length === 0) {
      continue;
    }

    group.sort((a, b) => a.index - b.index);

    if (group.length === 1) {
      const only = group[0];
      if (only == null) {
        continue;
      }
      result.set(only.index, {
        displayLatitude: only.latitude,
        displayLongitude: only.longitude,
        anchorLatitude: only.latitude,
        anchorLongitude: only.longitude,
        showSpiderLeg: false,
      });
      continue;
    }

    let sumLatitude = 0;
    let sumLongitude = 0;
    for (let k = 0; k < group.length; k += 1) {
      const member = group[k];
      if (member == null) {
        continue;
      }
      sumLatitude += member.latitude;
      sumLongitude += member.longitude;
    }
    const anchorLatitude = sumLatitude / group.length;
    const anchorLongitude = sumLongitude / group.length;

    const spreadScale = Math.min(
      2.4,
      Math.sqrt(Math.max(1, group.length / 2))
    );
    const fan = computeSpiderFanOffsetsMeters(group.length);
    for (let j = 0; j < group.length; j += 1) {
      const member = group[j];
      const offset = fan[j];
      if (member == null || offset == null) {
        continue;
      }
      const scale =
        (radiusMeters / SPIDER_DEFAULT_RADIUS_METERS) * spreadScale;
      const position = offsetLatLngByMetersNorthEast(
        anchorLatitude,
        anchorLongitude,
        offset.northMeters * scale,
        offset.eastMeters * scale
      );
      result.set(member.index, {
        displayLatitude: position.latitude,
        displayLongitude: position.longitude,
        anchorLatitude,
        anchorLongitude,
        showSpiderLeg: true,
      });
    }
  }

  return result;
}
